"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

var Button =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Button, _React$Component);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleKeyPress = function (event) {
      if (event.charCode === 13 || event.charCode === 32) {
        event.preventDefault();
        event.stopPropagation();

        _this.props.onClick();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disabled = _this$props.disabled,
          icon = _this$props.icon,
          iconSize = _this$props.iconSize,
          inToolbar = _this$props.inToolbar,
          onClick = _this$props.onClick,
          style = _this$props.style,
          title = _this$props.title,
          vertical = _this$props.vertical;
      var buttonClassName = (0, _classnames.default)((0, _defineProperty2.default)({
        'button relative': true,
        'disabled': disabled,
        'in-toolbar': inToolbar
      }, className, className));

      if (inToolbar || vertical) {
        return _react.default.createElement("div", {
          style: (0, _extends2.default)({}, style),
          onClick: onClick,
          className: buttonClassName,
          onMouseEnter: this.props.onMouseEnter,
          onMouseLeave: this.props.onMouseLeave,
          onKeyPress: this.handleKeyPress
        }, _react.default.createElement("div", {
          className: "icon"
        }, icon && _react.default.createElement(_Icon.default, {
          icon: icon,
          fontSize: "22px"
        })), title && _react.default.createElement("div", {
          className: "label"
        }, title));
      }

      return _react.default.createElement("div", {
        style: style,
        className: buttonClassName,
        onClick: onClick,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onKeyPress: this.handleKeyPress
      }, icon && _react.default.createElement(_Icon.default, {
        style: {
          marginRight: title ? 3 : -1
        },
        icon: icon,
        fontSize: iconSize
      }), title && _react.default.createElement("span", {
        className: "inline-block label nowrap center"
      }, title), children);
    }
  }]);
  return Button;
}(_react.default.Component);

Button.defaultProps = {
  disabled: false,
  icon: null,
  inToolbar: false,
  title: null,
  vertical: false
};
var _default = Button;
exports.default = _default;